import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/explorebylocalities.css"; // Import the CSS file
import building from "../../images/2989102.jpg";

const localities = [
  {
    name: "Kelambakkam",
    priceRange: "Starting from ₹27L",
    description: "Find The Perfect Place to Live With your Family",
  },
  {
    name: "Sholinganallur",
    priceRange: "Starting from ₹ 3.60Cr",
    description: "Find The Perfect Place to Live With your Family",
  },
  {
    name: "Selaiyur",
    priceRange: "Starting from ₹ 34L",
    description: "Find The Perfect Place to Live With your Family",
  },
];

const ExploreByLocalities = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState(""); 

  const handleSearch = (localityName) => {
    const queryParams = new URLSearchParams();
    
    if (localityName) {
      queryParams.set("locality", localityName); 
    } else if (searchQuery.trim()) {
      queryParams.set("locality", searchQuery); 
    }

    queryParams.set("propertyType", "Residential");
    navigate(`/search?${queryParams.toString()}`);
  };
const handleclickcontact = () => {
  navigate('/contact');
}
  return (
    <section className="explore-section">
      <h2 className="explore-heading">Explore by Localities</h2>
      <div className="localities-container">
        {/* Left Explore Box */}
        <div className="explore-box">
          <h3 className="explore-title">Explore</h3>
          <p className="explore-subtitle">Popular Localities in Chennai</p>
          <button className="view-all-btn" >View All</button>
        </div>

        {/* Locality Cards */}
        <div className="cards-container">
          {localities.map((locality, index) => (
            <div key={index} className="locality-card">
              <h3 className="locality-name">{locality.name}</h3>
              <p className="locality-price">{locality.priceRange}</p>
              <p className="locality-description">{locality.description}</p>
              <div className="property-link">
                <button
                  onClick={() => handleSearch(locality.name)} 
                  className="view-properties-btn"
                >
                  View Properties →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="dream-banner">
        <div>
          <h3 className="banner-title">Your Perfect Home Is Just a Call Away!</h3>
          <p className="banner-text1">
          0% Brokerage | Verified Properties | Expert Support in Chennai
          </p>
        </div>
        <button onClick={handleclickcontact} className="contact-btn1">Contact Now</button>
      </div>
    </section>
  );
};

export default ExploreByLocalities;
